import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1370e068"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mx-auto px-4 py-6" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex space-x-1 text-sm text-gray-500 navigate px-4" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "" }, "Home"),
  /*#__PURE__*/_createElementVNode("div", null, ">"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-primary font-semibold" }, "Donate")
], -1))

import { defineComponent } from 'vue';
import DonateProvider from '@/components/Donate/DonateProvider.vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

defineComponent({
  name: 'DonateView',
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(DonateProvider)
  ]))
}
}

})